<template>
  <div class="vch-slider" :class="{ '-search-results': isSearchSlider }">
    <div class="vch-grid mb-lg">
      <div class="vch-col-12">
        <h2
          v-if="title"
          class="vch-slider__title heading-xl"
          :id="`title-text-${format}`"
        >
          {{ title }}
        </h2>
      </div>

      <template v-if="isSearchSlider">
        <div class="vch-col-12 vch-slider__results-mobile">
          <h2 class="heading-md uppercase">
            <span class="heading-md-em">{{ resultsCount }}</span>
            {{ shortDescription }}
          </h2>
          <div class="vch-slider__see-all-link -mobile">
            <a
              :class="['text-body-cap', seeAllClass]"
              @click="analyticsOnClick"
              :href="seeLink"
              v-if="seeLink && seeLinkText"
              >{{ seeLinkText }}</a
            >
          </div>
        </div>
      </template>
    </div>
    <div class="vch-grid">
      <div class="vch-col-12 vch-col-md-12">
        <template v-if="isSearchSlider">
          <h2
            class="vch-slider__description heading-md uppercase"
            v-if="shortDescription"
          >
            <span class="heading-md-em">{{ resultsCount }}</span>
            {{ shortDescription }}
          </h2>
        </template>
        <template v-else>
          <p class="vch-slider__description text-body" v-if="shortDescription">
            {{ shortDescription }}
          </p>
        </template>
      </div>
      <div class="vch-col-12 vch-slider__see-all-link -desktop">
        <a
          :class="['text-body-cap', seeAllClass]"
          @click="analyticsOnClick"
          :href="seeLink"
          v-if="seeLink && seeLinkText"
          >{{ seeLinkText }}</a
        >
      </div>
      <div
        :class="[
          'vch-col-12',
          cardType === 'full-width' ? 'vch-col-md-12' : 'vch-col-md-9',
        ]"
      >
        <div
          class="vch-slider__see-all-link"
          :class="{ '-mobile': !isSearchSlider }"
        >
          <a
            :class="['text-body-cap', seeAllClass]"
            @click="analyticsOnClick"
            :href="seeLink"
            v-if="seeLink && seeLinkText"
            >{{ seeLinkText }}</a
          >
        </div>
        <div :class="['vch-slider__content', `vch-slider__content--${format}`]">
          <vch-card-scroller
            :format="format"
            :cardType="cardType"
            :ariaTitle="`title-text-${format}`"
            :prev-aria-label="prevAriaLabel"
            :next-aria-label="nextAriaLabel"
          >
            <slot />
          </vch-card-scroller>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'VchSlider',
  props: {
    format: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    seeLink: {
      type: String,
      required: false,
    },
    seeLinkText: {
      type: String,
      required: false,
    },
    seeAllClass: {
      type: String,
      required: false,
    },
    seeAllData: {
      type: String,
      required: false,
    },
    shortDescription: {
      type: String,
      required: false,
    },
    resultsCount: {
      type: String,
      required: false,
    },
    cardType: {
      type: String,
      required: false,
      default: 'full-width'
    },
    prevAriaLabel:{
      type: String,
      required: false,
      default: 'Previous'
    },
    nextAriaLabel:{
      type: String,
      required: false,
      default: 'Next'
    },
  },
  computed: {
    isSearchSlider() {
      return this.resultsCount && this.resultsCount.length;
    },
  },
  mounted() {
    if (screen.width >= 1600) {
      const container = document.getElementById('title-text-' + this.format);
      const textLength = container.innerText.length;
      if (textLength > 13) {
        container.style.width = '84%';
      }
    }
  },
  methods: {
    analyticsOnClick() {
      const analyticsData = JSON.parse(this.seeAllData);
      if (analyticsData && analyticsData.eventProperties) {
        pushEvent({
          event: 'uaevent',
          event_name: analyticsData.eventProperties.event_name
            ? analyticsData.eventProperties.event_name
            : 'body_button_click',
          ecommerce: 'undefined',
          eventCategory: analyticsData.eventProperties.eventCategory
            ? analyticsData.eventProperties.eventCategory
            : 'undefined',
          eventAction: analyticsData.eventProperties.eventAction
            ? analyticsData.eventProperties.eventAction
            : 'undefined',
          eventLabel: analyticsData.eventProperties.eventLabel
            ? analyticsData.eventProperties.eventLabel
            : 'undefined',
          module_name: analyticsData.eventProperties.module_name
            ? analyticsData.eventProperties.module_name
            : 'undefined',
          cta_name: analyticsData.eventProperties.cta_name
            ? analyticsData.eventProperties.cta_name
            : 'undefined',
          link_url: analyticsData.eventProperties.link_url
            ? analyticsData.eventProperties.link_url
            : 'undefined',
        });
      }
    },
  },
};
</script>
<style lang="scss" src="./slider.scss"></style>
